import { render } from "./8_servicios.vue?vue&type=template&id=6cca9392&scoped=true"
import script from "./8_servicios.vue?vue&type=script&lang=js"
export * from "./8_servicios.vue?vue&type=script&lang=js"

import "./8_servicios.vue?vue&type=style&index=0&id=6cca9392&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cca9392"]])

export default __exports__